import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import FormStyles from './components/common/FormStyles';

// Layouts
import UserLayout from './layouts/UserLayout';
import AdminLayout from './layouts/AdminLayout';
import AuthLayout from './layouts/AuthLayout';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';

// User Pages
import UserDashboard from './pages/user/Dashboard';
import Courses from './pages/user/Courses';
import CourseDetail from './pages/user/CourseDetail';
import PhishingReporter from './pages/user/PhishingReporter';
import UserProfile from './pages/user/Profile';

// Admin Pages
import AdminDashboard from './pages/admin/Dashboard';
import UserManagement from './pages/admin/UserManagement';
import ContentManagement from './pages/admin/ContentManagement';
import CampaignManagement from './pages/admin/CampaignManagement';
import DomainSettings from './pages/admin/DomainSettings';
import Reports from './pages/admin/Reports';
import CampaignWizard from './pages/admin/CampaignWizard';

const App = () => {
  return (
    <AuthProvider>
      <FormStyles />
      
      <Router>
        <Routes>
          {/* Auth Routes */}
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
          </Route>
          
          {/* User Routes */}
          <Route element={<ProtectedRoute roles={['user']} />}>
            <Route element={<UserLayout />}>
              <Route path="/" element={<UserDashboard />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/courses/:id" element={<CourseDetail />} />
              <Route path="/reporter" element={<PhishingReporter />} />
              <Route path="/profile" element={<UserProfile />} />
            </Route>
          </Route>
          
          {/* Admin Routes */}
          <Route element={<ProtectedRoute roles={['admin']} />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<UserManagement />} />
              <Route path="/admin/content" element={<ContentManagement />} />
              <Route path="/admin/campaigns" element={<CampaignManagement />} />
              <Route path="/admin/campaigns/new" element={<CampaignWizard />} />
              <Route path="/admin/domains" element={<DomainSettings />} />
              <Route path="/admin/reports" element={<Reports />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App; 